import { NgModule } from '@angular/core';
import { FirebaseService } from './services/firebase.service';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { MessagingService } from './services/messaging.service';
import { AngularFireFunctionsModule } from '@angular/fire/compat/functions';

@NgModule({
  imports: [
    MatSnackBarModule,
    TranslateModule,
    RouterModule,
    AngularFireMessagingModule,
    AngularFireFunctionsModule
  ],
  providers: [FirebaseService, MessagingService],
})
export class FirebaseModule {}
